/* eslint-disable react/react-in-jsx-scope */
import { Checkbox } from "@/components/ui/checkbox";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import { useEffect, useState } from "react";
import FilterItem from "./FilterItem";

const DropdownFilterCat = ({
  options,
  name,
  value,
  slug,
  handleChange,
}: {
  options: any[];
  name: string;
  value: string[];
  slug: string;
  handleChange: (slug: string, value: string[]) => void;
}) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(value);

  useEffect(() => {
    setSelectedValues(value);
  }, [value]);

  const handleBlur = () => {
    const hasChanged =
      selectedValues.length !== value.length ||
      !selectedValues.every((val) => value.includes(val));

    if (hasChanged) {
      handleChange(slug, selectedValues);
    }
  };

  const handleCheckboxChange = (optionValue: string, isChecked: boolean) => {
    setSelectedValues((prev) => {
      if (isChecked) {
        if (!prev.includes(optionValue)) {
          return [...prev, optionValue];
        }
      } else {
        return prev.filter((item) => item !== optionValue);
      }
      return prev;
    });
  };

  const allSelected = options.every((opt) =>
    selectedValues.includes(opt.value)
  );

  const toggleAll = (checked: boolean) => {
    if (!checked) {
      setSelectedValues([]);
      handleChange(slug, []);
      return;
    }

    const allValues = options.flatMap((opt) => [
      opt.value,
      ...(opt.children?.map((child) => child.value) || []),
    ]);

    setSelectedValues(allValues);
    handleChange(slug, allValues);
  };

  const handleGroupCheckboxChange = (
    optionValue: string,
    isChecked: boolean,
    children: number[]
  ) => {
    console.log("ato");
    setSelectedValues((prev) => {
      if (isChecked) {
        if (!prev.includes(optionValue)) {
          return [...prev, ...children, optionValue];
        }
      } else {
        return prev.filter(
          (item) => item !== optionValue && !children.includes(Number(item))
        );
      }
      return prev;
    });
  };

  return (
    <div className="relative">
      <DropdownMenu onOpenChange={(open) => !open && handleBlur()}>
        <DropdownMenuTrigger asChild>
          <button className="text-xs py-[3px] h-[26px] border  rounded-md px-3 font-normal flex gap-1 items-center">
            {name}
            <ChevronDown size={16} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          onCloseAutoFocus={(e) => e.preventDefault()}
          className="max-h-64 overflow-auto transition-all"
        >
          <DropdownMenuLabel className="flex justify-between">
            <div className="flex justify-between w-full">
              <div className="flex gap-1 items-center">
                {/* La prop `checked` est maintenant directement liée à l'état `allSelected` qui est mis à jour après `toggleAll` */}
                <Checkbox
                  checked={allSelected}
                  onCheckedChange={(checked) => toggleAll(checked as boolean)}
                  id={name}
                />
                <label htmlFor={name}>{name}</label>
              </div>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          {options.map(
            (option, i) =>
              option.label && (
                <FilterItem
                  key={i}
                  option={option}
                  selectedValues={selectedValues}
                  handleCheckboxChange={handleCheckboxChange}
                  handleGroupCheckboxChange={handleGroupCheckboxChange}
                />
              )
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default DropdownFilterCat;
